import { render, staticRenderFns } from "./sydSelectSp.vue?vue&type=template&id=ef61c490"
import script from "./sydSelectSp.vue?vue&type=script&lang=js"
export * from "./sydSelectSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports